import { DEVICES, OS } from 'src/constants';
import { IAppPage } from 'src/interface';
import { IAppConfig, IAppRegion } from 'src/services/AppService';

export const ACTIONS = {
    CONFIG_UPDATE: 'APP_CONFIG_UPDATE',
    PAGE_UPDATE: 'PAGE_UPDATE',
    REGION_UPDATE: 'REGION_UPDATE',
    IS_ONLINE_UPDATE: 'IS_ONLINE_UPDATE',
    DEVICE_UPDATE: 'DEVICE_UPDATE',
};

export const configUpdate = (value: IAppConfig) => ({
    type: ACTIONS.CONFIG_UPDATE,
    payload: value,
});

export const regionUpdate = (value: IAppRegion) => ({
    type: ACTIONS.REGION_UPDATE,
    payload: value,
});

export const pageUpdate = (value: IAppPage) => ({
    type: ACTIONS.PAGE_UPDATE,
    payload: value,
});

export const isOnlineUpdate = (isOnline: boolean) => ({
    type: ACTIONS.IS_ONLINE_UPDATE,
    payload: isOnline,
});

export const deviceUpdate = (
    device: DEVICES,
    os: OS,
    isIABM: boolean,
    isZalo: boolean,
    isBot: boolean,
    isMiniapp: boolean
) => ({
    type: ACTIONS.DEVICE_UPDATE,
    payload: { device, os, isIABM, isZalo, isBot, isMiniapp },
});
